<template>
  <!-- 资金明细(流水) -->
  <div class="home-page-container">
    <el-card style="margin:0 0 10px 0">
      <mer-search :searchConfig="formConfig" :searchBar="searchBar"
        @search="searchList"
        @reset="reset"
        @changeTime="(value,model)=>changeTime(value,'searchBar', 'tradingTimeStart', 'tradingTimeEnd')"
        @changeOption="changeOption"
        :loading="tableLoading">
        <template slot="account">
          <el-select v-if="showMultipleAccount" v-model="searchBar.accountCode" :clearable="false" @change="changeAccount">
            <el-option v-for="(item,key) in accountOptions" :key="key" :label="item.accountName" :value="item.accountCode"></el-option>
          </el-select>
          <span v-else class="account-text">{{ accountName || ''}}</span>
        </template>
        <template slot="handler">
          <!-- <el-button size="mini" @click="download" icon="el-icon-download">导出</el-button> -->
          <download-button :downloadApi="downloadDetailsApi" :queryParams="{ ...downloadParams }" @countPoint="$track.clickEvent('按钮：导出', 1634182520)"></download-button>
        </template>
      </mer-search>
    </el-card>
    <el-card style="margin: 20px 0 10px" shadow="never">
      <div class="sum-wrapper">
        <div class="sum-item sum-item-1">
          <div class="value">{{sumInfo.incomeCount || 0}}</div>
          <div class="label">收入(笔)</div>
        </div>
        <div class="sum-item sum-item-2">
          <div class="value">{{sumInfo.income || 0}}</div>
          <div class="label">收入金额(元)</div>
        </div>
        <div class="sum-item sum-item-3">
          <div class="value">{{sumInfo.expenditureCount || 0}}</div>
          <div class="label">支出(笔)</div>
        </div>
        <div class="sum-item sum-item-4">
          <div class="value">{{sumInfo.expenditure || 0}}</div>
          <div class="label">支出金额(元)</div>
        </div>
      </div>
    </el-card>
    <el-card>
      <div class="tips">提示：资金账户发起提现后，清分银行进行订单清分结算及记录展示</div>
      <mer-table :loading="tableLoading"
        :tableConfig="tableConfig"
        :tableData="tableData"
        :pagination="pagination"
        @SizeChange="handleSizeChange"
        @PageChange="pageChange">
        <template slot="handler" slot-scope="{row}">
          <!-- <el-button-group v-if="row.tradingTypeName === '提现' && searchBar.accountCode !== 2">
            <el-button size="mini" @click="showDetail(row)">查看回执单</el-button>
          </el-button-group> -->
          <el-dropdown
            v-if="row.tradingTypeName === '提现' && searchBar.accountCode !== 2"
            trigger="click"
            @command="openReceipt"
            placement="bottom">
            <el-button type="primary" size="mini" @click="showDetail(row)">
              查看回执单<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in receiptList" :key="index" :command="item">{{`电子回单${index + 1}`}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </mer-table>
    </el-card>
    <!-- 回执单弹窗 -->
    <el-dialog
      class="receipt"
      title="回执单"
      :visible.sync="dialogVisible"
      width="422px">
      <span class="msg">因平安银行回执单下载机制，请将电子回单号和回单查询码复制后到指定的网址查询。</span>
      <div class="box">
        <p style="margin-bottom: 8px"><span class="text">电子回单号：{{activeRow.receiptNumber || ''}}</span><span class="copy" @click="copy(1)">复制</span></p>
        <p><span class="text">回单验证码：{{activeRow.code || ''}}</span><span class="copy" @click="copy(2)">复制</span></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goLocation">去填写</el-button>
      </span>
</el-dialog>
  </div>
</template>
<script>
import listPage from '@/mixins/listPage'
import queryMix from '@/views/finance/mixins/query';
import { getQueryTradeTypeApi, getDetailSummaryApi, getDetailListApi, downloadDetailsApi, getAllD0AccountApi, receiptView, getSignBodyList } from '@/api/finance'
import dayjs from 'dayjs'

// 查询表单配置
let formConfig = [
  { label: '签约主体', type: 'select', modelName: 'signBody', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'desc', selectValue: 'code' },
  { label: '当前账户', type:'slot', slotName: 'account'},
  { label: '交易时间', type: 'date', modelName: 'tradeTime', model: '', dateType: 'datetimerange', format: 'yyyy-MM-dd HH:mm:ss', clearable:false },
  { label: '交易类型', type: 'select', modelName: 'tradingType', placeholder: '全部', selectOptions: [], define: true, selectLabel: 'name', selectValue: 'code' }
]
// 表格参数配置
let tableConfig = [
  { label: '交易时间', prop: 'tradingTime', fixed: 'left', width: 150 },
  { label: '交易类型', prop: 'tradingTypeName' },
  { label: '交易方向', prop: 'tradingDirectionName' },
  { label: '交易金额(元)', prop: 'tradingAmount',width: 136 },
  { label: '交易后余额(元)', prop: 'balance',width: 136 },
  { label: '对应订单号', prop: 'orderNo',width: 136 },
  { label: '系统流水号', prop: 'serialNum',width: 136 },
  { label: '交易状态', prop: 'tradingStatusName'},
  { label: '备注', prop: 'remark', width: 210 },
  { label: '提现附言', prop: 'description', width: 210 },
  { label: '操作', slot: 'handler', fixed: 'right', width: 150 }
]
export default {
  name: 'finance_withdrawDetail',
  mixins:[ listPage, queryMix ],
  data(){
    return{
      dialogVisible: false,
      downloadDetailsApi,
      tradeTime:'',
      formConfig: formConfig,
      tableConfig: tableConfig,
      activeRow: {},
      sumInfo: {
        incomeCount: 0,
        income: 0,
        expenditureCount: 0,
        expenditure: 0
      },
      accountCode:'',   // 当前生效账户code
      accountName:'',    // 当前生效账户name
      accountOptions: [],    //多账号容器
      receiptList: [],
      signBodyResponseInfoList: []
    }
  },
  created(){
    this.reset()
    this.$track.pageViewEvent('页面：资金流水', '1634182517')
  },
  computed:{
    showMultipleAccount(){
      return this.accountName && this.accountOptions?.length > 1 
    }
  },
  methods:{
    searchList () {
      this.$track.clickEvent('按钮：查询', 1634182518)
      this.search()
    },
    async reset () {
      this.tradeTime = ''
      this.initTime('tradeTime', 0, 'searchBar', true, 'tradingTimeStart', 'tradingTimeEnd')
      const { tradeTime } = this
      const initObj = { tradeTime: [tradeTime, null] }
      this.setSearchConfig(initObj)
      this.$track.clickEvent('按钮：重置', 1634182519)
      await this.getSignBody()
      this.initList(getDetailListApi,true,getDetailSummaryApi)
    },
    // useDownload () {
    //   this.$track.clickEvent('按钮：导出', 1634182520)
    // },
    copy (type) {
      var text = type === 1 ? this.activeRow.receiptNumber : this.activeRow.code
      var input = document.createElement('input')
      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      document.execCommand('copy')
      document.getElementById('copyInput').remove()
      this.$message.success('复制成功')
    },
    // 获取查询条件：交易类型
    async getQueryProps (accountCode) {
      const { code, result = [] } = await getQueryTradeTypeApi({accountCode})
      if(code !== 200) return
      const initObj = { tradingType: result }
      this.setSearchConfig(initObj)
    },
    changeAccount(val){
      // 账户切换,交易类型清空
      this.$set(this.searchBar,'tradingType','')
      const initObj = { tradingType: [] }
      this.setSearchConfig(initObj)
      this.getQueryProps(val)
    },
    download () {
      this.downloadFile(downloadDetailsApi,'资金明细')
    },
    // 获取当前商户D0账户
    async getAllAccount(signBody){
      try{
        // 返回 account(账户类型) valid（是否当前生效的账户,生效账户只有一个） true生效中
        const { code, result = [] } = await getAllD0AccountApi({ signBody })
        if(code !== 200) return
        this.accountOptions = result || []
        let tempAccount = result.find(item => item.valid === true) || result[0]
        if(tempAccount){
          // 筛选出生效账户
          const {accountName, accountCode} = tempAccount
          this.accountCode = accountCode
          this.accountName = accountName
          //设置默认选中值
          this.$set(this.searchBar,'accountCode',accountCode)
        }
      }catch(err){
        console.log(err)
      }finally{
        // this.initList(getDetailListApi,true,getDetailSummaryApi,{accountCode:this.accountCode})
        // 无生效账户,不去请求任何接口
        if(this.accountName){
          this.getQueryProps(this.accountCode)
        }else{
          this.$message.warning('无生效账户')
        }
      }
    },
    async getSignBody() {
      const { code, result = [] } = await getSignBodyList()
      if(code !== 200) return
      const initObj = { signBody: result.signBodyResponseInfoList }
      this.signBodyResponseInfoList = result.signBodyResponseInfoList || []
      this.setSearchConfig(initObj)
      const defaultItem = result.signBodyResponseInfoList.find(item => item.use)
      this.$set(this.searchBar, 'signBody', defaultItem.code)
      await this.getAllAccount(defaultItem.code)
    },
    changeOption (val, model) {
      if (model === 'signBody') {
        val && this.getAllAccount(val)
        this.searchBar.accountCode = ''
      }
    },
    // 查看回执单
    async showDetail (row) {
      this.receiptList = []
      this.$track.clickEvent('按钮：查看回执单', 1634182521)
      // D0账户type为1
      let data = {
        transNumber: this.searchBar.accountCode ? row.orderNo : row.serialNum,
        type: 1
      }
      if (this.searchBar.accountCode === 0) data.channel = '华夏'
      if (this.searchBar.accountCode === 1) data.channel = '平安'
      if (this.searchBar.accountCode === 3) data.channel = '中信'
      if (this.searchBar.accountCode === 4) data.channel = '建行'
      try {
        const { code, result } = await receiptView(data)
        if (code !== 200) return
        this.receiptList = result.urlList
        this.activeRow = result || {}
      } catch (error) {
        console.log(error)
      }
    },
    goLocation () {
      this.dialogVisible = false
      window.open('https://ebank.sdb.com.cn/corporbank/attachedStandBookBillInput.do', '_blank')
    },
    async openReceipt (url) {
      if (this.searchBar.accountCode === 1) {
        this.dialogVisible = true
      } else {
        var a = document.createElement("a")
        a.setAttribute("href", url)
        a.setAttribute("target", "_blank")
        a.setAttribute("id", "camnpr")
        // a.style.display = 'none'
        document.body.appendChild(a)
        a.click();
      }
    },
    search () {
      if (dayjs(this.searchBar.tradingTimeEnd).valueOf() - dayjs(this.searchBar.tradingTimeStart).valueOf() > 31 * 24 * 3600 * 1000) {
        return this.$message.warning('查询范围不能超过31天')
      }
      this.pagination.pageIndex = 1
      // this.pagination.pageSize = 10
      this.refresh()
    }
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
.total-wrapper{
  margin: 15px 0px;
  .total-item{
    margin-right: 10px;
  }
}
.account-text{
  font-weight: 600;
}
.receipt {
  .msg {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }
  .box {
    width: 100%;
    height: 80px;
    background: #F8F8F8;
    border-radius: 4px; 
    padding: 12px 16px;
    margin-top: 16px;
    p {
      margin: 0;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
      .copy {
        margin-left: 8px;
        color: #4B7EFE;
        cursor: pointer;
      }
    }
  }
  /deep/.el-dialog__header, /deep/.el-dialog__footer{
    text-align: center;
  }
}
.tips {
  font-size: 12px;
  color: #909399;
  margin-left: 5px;
}
</style>